import React from 'react';

const ResourceDisplay = ({ resource }) => {
  if (!resource) return <div className="text-gray-500">No output available for this tab yet.</div>;

  const hasSections = resource.sections && resource.sections.length > 0;
  const hasQuestions = resource.questions && resource.questions.length > 0;
  const hasKeyConcepts = resource.keyConcepts && resource.keyConcepts.length > 0;

  if (!hasSections && !hasQuestions && !hasKeyConcepts) {
    return <div className="text-gray-500">No output available for this tab yet.</div>;
  }

  return (
    <div className="space-y-10">
      {hasSections && (
        <section>
          <h3 className="text-2xl sm:text-3xl font-extrabold mb-6 tracking-tight leading-tight">Sections</h3>
          <ul className="space-y-8">
            {resource.sections.map((section, idx) => (
              <li key={idx} className="mb-2">
                <div className="text-xl sm:text-2xl font-bold mb-2 leading-snug">{section.title}</div>
                <pre className="rounded-lg p-4 text-base sm:text-lg leading-relaxed font-mono whitespace-pre-wrap shadow-inner border border-gray-100">
                  {section.content}
                </pre>
              </li>
            ))}
          </ul>
        </section>
      )}
      {hasQuestions && (
        <section>
          <h3 className="text-2xl sm:text-3xl font-extrabold mb-6 tracking-tight leading-tight">Questions</h3>
          <ol className="list-decimal list-inside space-y-8 pl-4">
            {resource.questions.map((q, idx) => {
              if (typeof q === 'object' && q !== null && (q.question || q.options)) {
                return (
                  <li key={idx} className="mb-4">
                    <div className="text-lg sm:text-xl font-bold mb-3 leading-snug">{q.question}</div>
                    {Array.isArray(q.options) && q.options.length > 0 && (
                      <div className="rounded-lg p-4 font-mono text-base sm:text-lg leading-relaxed shadow-inner border border-gray-100">
                        {q.options.map((opt, oidx) => (
                          <div key={oidx} className="mb-2 pl-2 text-base sm:text-lg">{String.fromCharCode(97 + oidx)}) {opt}</div>
                        ))}
                      </div>
                    )}
                  </li>
                );
              } else {
                return (
                  <li key={idx} className="text-lg sm:text-xl font-bold mb-4 leading-snug">
                    {q}
                  </li>
                );
              }
            })}
          </ol>
        </section>
      )}
      {hasKeyConcepts && (
        <section>
          <h3 className="text-2xl sm:text-3xl font-extrabold mb-6 tracking-tight leading-tight">Key Concepts</h3>
          <ul className="list-disc list-inside space-y-4 pl-4">
            {resource.keyConcepts.map((concept, idx) => (
              <li key={idx} className="text-lg sm:text-xl font-semibold leading-snug">
                {concept}
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
};

export default ResourceDisplay; 